import type { AssistantJobStatus, AssistantStepStatus, AssistantStepType } from './types'

export const ASSISTANT_STEP_STATUSES: AssistantStepStatus[] = [
  'pending',
  'running',
  'done',
  'failed',
  'skipped',
]

export const ASSISTANT_JOB_STATUSES: AssistantJobStatus[] = [
  'queued',
  'running',
  'done',
  'failed',
  'cancelled',
]

export const VOICEOVER_VIDEO_STEP_ORDER: AssistantStepType[] = [
  'get_current_project',
  'select_reference_media',
  'generate_reference_images',
  'save_generated_images_to_media',
  'generate_tts_audio',
  'save_generated_audio_to_media',
  'insert_audio_to_timeline',
  'transcribe_media',
  'prepare_materials',
  'insert_transcript_as_captions',
  'generate_bgm',
  'attach_bgm_to_timeline',
  'start_export',
]
